import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { Icons } from '@lemon/assets';
import { isGoodsNotFoundError, useGoods } from '@lemon/goods';
import { LoadingFallback } from '@lemon/shared';

import { Goods } from '../../goods/Goods';

export const GoodsPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { id: routeId } = useParams<{ id: string }>();
    const queryId = searchParams.get('id')?.trim();
    const resolvedId = queryId || routeId;

    const { data, isLoading, error } = useGoods(resolvedId);

    if (!resolvedId) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <p className="text-red-600 mb-4">상품 정보를 찾을 수 없어요. 올바른 링크인지 확인해 주세요.</p>
                    <button
                        onClick={() => navigate(-1)}
                        className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800"
                    >
                        이전 페이지로 이동
                    </button>
                </div>
            </div>
        );
    }

    if (isLoading) {
        return <LoadingFallback />;
    }

    if (isGoodsNotFoundError(error)) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <p className="text-red-600 mb-2">존재하지 않는 상품이에요.</p>
                    <p className="text-gray-600 mb-4">링크가 변경되었거나 삭제된 상품입니다.</p>
                    <button
                        onClick={() => navigate('/home', { replace: true })}
                        className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800"
                    >
                        홈으로 이동
                    </button>
                </div>
            </div>
        );
    }

    if (error || !data) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <p className="text-red-600 mb-4">상품 정보를 불러오지 못했어요. 잠시 후 다시 시도해 주세요.</p>
                    <button
                        onClick={() => navigate(-1)}
                        className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800"
                    >
                        이전 페이지로 이동
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full min-h-screen flex justify-center">
            <div className="w-full max-w-[480px]">
                <div className="w-full h-14 px-4 flex justify-between items-center">
                    <img src={Icons.logo} alt="logo" />
                </div>
                <Goods data={data} />
            </div>
        </div>
    );
};
